module.exports = __webpack_public_path__ + "static/img/icon_store_tab.b8e000a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_store_tab.png
// module id = J27V
// module chunks = 1